// src/utils/leafletIcons.js — Instead of mutating Leaflet's shared
// Icon.Default prototype (a well-known fragile pattern that can crash
// with "Cannot read properties of undefined (reading 'createIcon')"
// depending on load/render order), every marker in this app is given
// an explicit icon directly. Nothing shared ever gets touched, so
// there's nothing to patch, no ordering to get right, and no risk of
// it breaking depending on which pages loaded first.
import L from 'leaflet';

export const defaultIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const staleIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  className: 'opacity-60 sepia',
});

export default L;
